<template>
	<div class="create-task-container" :class="taskDetail ? 'pb-4':'mt-4'">
		<div v-if="taskDetail" class="top-line"></div>
		<div v-if="taskDetail" class="pt-3 px-6 task-title">
			<div class="title-text">
				<span>Create {{ isSubTaskCreation ? 'Subtask':'Task' }}</span>
			</div>
			<v-icon @click.stop="onCreateTaskClose()">mdi-close</v-icon>
		</div>
		<v-alert class="mx-6 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressLinear v-if="loading"/>
		<div class="px-6" @click="close_selection += 1">
			<v-row class="mt-3">
				<v-col cols="12" class="py-0">
					<div class="item-text" :class="job && job.id === 0 && click_flag > 0 || error_job_flag ? 'item-text-error':'item-text-able'">Job</div>
					<v-autocomplete
						v-if="!loading"
						v-model="job"
						:items="jobItems"
						:loading="jobLoading"
						:search-input.sync="jobSearch"
						:color="color"
						background-color="#FAFAFA"
						item-text="display_name"
						item-value="id"
						item-color="success"
						item-disabled="disabled"
						autofocus
						auto-select-first
						outlined
						dense
						hide-no-data
						return-object
						hide-details
						clearable
						:disabled="isSubTaskCreation"
						:error="job && job.id === 0 && click_flag > 0 || error_job_flag || (job && !job.valid)"
						@change="onJobSelected($event)"
					>
						<template v-slot:prepend-inner>   
							<SuitCase :color="job && job.id === 0 && click_flag > 0 || error_job_flag ? '#F45252':'rgba(25, 42, 62, 0.5)'" width="24" height="24"/>
						</template>
					</v-autocomplete>
					<div class="mb-2" :class="job && !job.valid ? 'task-title':''">
						<div v-if="job && !job.valid" class="optional-text-red">Task cannot be added to a Complete/Cancelled Job</div>
						<div style="text-align: right" class="optional-text" :style="job && job.id === 0 && click_flag > 0 || error_job_flag ? 'color:#F45252':''">required</div>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text" :class="!phase && click_flag > 0 || error_phase_flag ? `item-text-error`:`item-text-able`">Phase</div>
					<v-select
						v-model="phase"
						:color="color"
						background-color="#FAFAFA"
						:items="phaseItems"
						item-text="display_name"
						item-value="id"
						item-color="success"
						return-object
						outlined
						dense
						hide-details
						:error="!phase && click_flag > 0 || error_phase_flag"
						:disabled="isSubTaskCreation"
						@change="onPhaseChange()"
					>
						<template v-slot:prepend-inner>   
							<Phase :color="!phase && click_flag > 0 || error_phase_flag ? '#F45252': 'rgba(25, 42, 62, 0.5)'"/>     
						</template>
					</v-select>
					<div style="text-align: right" class="optional-text" :style="!phase && click_flag > 0 || error_phase_flag ? 'color:#F45252':''">required</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text" :class="!task_status && click_flag > 0 || error_task_status_flag ? `item-text-error`:`item-text-able`">Task Status</div>
					<v-select
						v-model="task_status"
						:color="color"
						background-color="#FAFAFA"
						:items="task_statusses"
						item-text="desc"
						item-value="id"
						item-color="success"
						outlined
						dense
						hide-details
						return-object
						:error="!task_status && click_flag > 0 || error_task_status_flag"
						@change="onStatusChange()"
					>
						<template v-slot:selection="{ item }">
							<span>
								<v-badge
									:color="item.color"
									left
									inline
								>
									<span class="ml-1">{{ item.desc }}</span>
								</v-badge>
							</span>
						</template>
						<template v-slot:item="{item, on}">
							<v-list-item v-on="on" dense>
								<v-badge
									:color="item.color"
									left
									inline
								>
									<span class="ml-1">{{ item.desc }}</span>
								</v-badge>					
							</v-list-item>
						</template>
					</v-select>
					<div style="text-align: right" class="optional-text" :style="!task_status && click_flag > 0 || error_task_status_flag ? 'color:#F45252':''">required</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="py-0">
					<div class="item-text" :class="!task_name && click_flag > 0 || error_task_name_flag ? 'item-text-error':'item-text-able'">Task name</div>
					<v-text-field
						v-model="task_name"
						:color="color"
						background-color="#FAFAFA"
						outlined
						dense
						clearable
						hide-details
						:error="!task_name && click_flag > 0 || error_task_name_flag"
						@change="onTaskNameChange()"
					></v-text-field>
					<div style="text-align: right" class="optional-text" :style="!task_name && click_flag > 0 || error_task_name_flag ? 'color:#F45252':''">required</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text">Kind</div>
					<KindTreeSelection
						:isKindIcon="true"
						:color="color"
						:bgColor="'#FAFAFA'"
						:kindSelected="kind_selected"
						:kindParams="kindParams"
						:closeSelection="close_selection"
						:isWidthAuto="true"
						@kind-selected="onKind($event)"
					/>
					<div class="optional-text">optional</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:3" class="py-0">
					<div class="item-and-icon">
						<div :class="`item-text ${budget_type === 0 || budget_type === 1 ? 'item-text-disable':'item-text-able'}`">Task hours</div>
						<v-icon color="#B9C2CB" v-if="budget_type === 0 || budget_type === 1" small>mdi-lock-outline</v-icon>
					</div>
					<v-text-field
						v-if="budget_type == 0 || budget_type === 1"
						v-model="budget"
						:color="color"
						background-color="#FAFAFA"
						disabled
						outlined
						dense
						hide-details
					></v-text-field>
					<v-text-field
						key="budget_type_2"
						v-if="budget_type == 2"
						v-model="budget"
						:color="color"
						background-color="#FAFAFA"
						:disabled="budget_type === 0"
						:rules="rules"
						placeholder="eg, 10h 15m"
						outlined
						dense
						hide-details
						@change="onBudget($event)"
					></v-text-field>
					<div v-if="budget_type == 2" style="text-align: right" class="optional-text">optional</div>
				</v-col>
				<v-col v-if="showBudget" :cols="$vuetify.breakpoint.xsOnly ? 12:3" :class="$vuetify.breakpoint.xsOnly ? '':'py-0'">
					<div class="item-and-icon">
						<div :class="`item-text ${budget_type === 0 ? 'item-text-disable':'item-text-able'}`">Task budget</div>
						<v-icon color="#B9C2CB" v-if="budget_type === 0" small>mdi-lock-outline</v-icon>
					</div>
					<v-text-field
						v-if="budget_type == 0"
						v-model="budget"
						:color="color"
						background-color="#FAFAFA"
						disabled
						outlined
						dense
						hide-details
					></v-text-field>
					<v-text-field
						key="budget_type_1"
						v-if="budget_type == 1 || budget_type === 2"
						v-model="amount"
						:color="color"
						background-color="#FAFAFA"
						:prefix="currency && currency.symbol"
						placeholder="enter the amount of task"
						outlined
						dense
						hide-details
						type="number"
						min="0"
						oninput="if(this.value < 0) this.value = 0;"
						@change="onAmount($event)"
					></v-text-field>
					<div v-if="budget_type !== 0" style="text-align: right" class="optional-text">optional</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text">Priority</div>
					<v-select
						v-model="priority"
						:color="color"
						background-color="#FAFAFA"
						:items="priority_levels"
						item-color="success"
						outlined
						dense
						hide-details
						@change="onPriorityChange()"
					>
						<template v-slot:prepend-inner>   
							<v-icon color="rgba(25, 42, 62, 0.5)">mdi-star-half-full</v-icon>   
						</template>
					</v-select>
					<div class="optional-text">optional</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text">Mark as</div>
					<v-btn-toggle v-model="ac_oc" borderless>
						<v-btn
							class="mr-2 rounded"
							:color="ac_oc == ac_type ? 'rgba(129, 204, 0, 0.25)':''"
							:value="ac_type"
							depressed
							min-width="44" 
							max-width="44" 
							min-height="40" 
							max-height="40" 
						>
							AC
						</v-btn>
						<v-btn
							class="rounded"
							:color="ac_oc == oc_type ? 'rgba(129, 204, 0, 0.25)':''"
							:value="oc_type"
							depressed 
							min-width="44" 
							max-width="44" 
							min-height="40" 
							max-height="40" 
						>
							OC
						</v-btn>
					</v-btn-toggle>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-text">Assigned to</div>
					<AssignedTreeSelection
						:color="color"
						:bgColor="'#FAFAFA'"
						:selected="assigned"
						:closeSelection="close_selection"
						:kinds="[kind]"
						@assign-selected="onAssignChange($event)"
					/>
					<div class="optional-text">optional</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0">
					<div class="item-and-icon">
						<div class="item-text-disable">Account executive</div>
						<v-icon color="#B9C2CB" small>mdi-lock-outline</v-icon>
					</div>
					<v-select
						v-model="account_director"
						:items="account_director_items"
						item-text="name"
						item-value="id"
						item-color="success"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
						disabled
					>
						<template v-slot:prepend-inner> 
							<v-user-avatar
								v-if="account_director && account_director.code.length !== 0"
								:size="`24px`"
								:code="account_director.code"
								:image="account_director.image"
							/> 
						</template>
					</v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col v-if="false" :cols="isRecurring? 6:5" class="py-0">
					<v-radio-group dense v-model="radio_group" :class="isRecurring ? 'mt-0': ''">
						<v-radio
							v-if="isRecurring"
							label="Automatically calculate budget using recurrences"
							:color="color"
							:value="automatically"
							dense
						></v-radio>
						<v-radio
							label="Manually input task budget"
							:color="color"
							:value="manually"
							dense
						></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:2">
					<div class="item-text">Days</div>
					<v-text-field
						v-model="days"
						:color="color"
						type="number"
						class="text-right"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
						min="0"
						oninput="if(this.value < 0) this.value = 0;"
						@change="days = Number.parseInt($event)"
					></v-text-field>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:8">
					<DateMulti
						:lableText="'Start date to End date'"
						:suggestionText="$vuetify.breakpoint.xsOnly ? 'eg, 12/3/2022-13/3/2022':'eg, 120322-130322 or 12/3/2022-13/3/2022'"
						:color="color"
						:background="`#FAFAFA`"
						:isOptional="true"
						:disabled="budget_type === 3"
						:workdays="workdays"
						:validRange="date_range"
						:dateStartInit="date_start_init"
						:dateEndInit="date_end_init"
						:days="Number.parseInt(days)"
						@dateRange="onDateChange($event)"
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:2" align-self="start" :class="$vuetify.breakpoint.xsOnly ? 'pt-0':''">
					<div :class="$vuetify.breakpoint.xsOnly ? 'task-title':'task-title mt-2'">
						<v-checkbox
							:disabled="budget_type !== 2 && budget_type !== 1"
							v-model="isAllday"
							:color="color"
							label="All day"
							dense
							hide-details
							@change="onButtonActive()"
						></v-checkbox>
					</div>
				</v-col>
				<v-col v-if="false" :cols="2">
					<v-switch
						v-model="isRecurring"
						:color="color"
						@change="onRecurring($event)"
						label="Recurring"
						inset
						dense
					></v-switch>
				</v-col>
			</v-row>
			<v-row class="mt-0 mb-2" v-if="!isAllday">
				<DateTime
					:color="color"
					:duration="budget"
					:colsNumber="3"
					:startTimeInit="time_start_init"
					:endTimeInit="time_end_init"
					:startError="start_time_error"
					:endError="end_time_error"
					:isOptional="true"
					:disabled="budget_type === 3"
					:styleLeft="`pt-0`"
					:styleRight="`pt-0`"
					@time_start="onTimeStartChange($event)"
					@time_end="onTimeEndChange($event)"
				/>
			</v-row>
			<div @click="onCreateCheck()">
				<v-btn 
					class="text-capitalize white--text my-3"
					color="#00AAFD"
					:disabled="!isActive"
					block 
					depressed
					@click="onCreate()"
				>
					<v-icon class="mr-1">
						mdi-plus
					</v-icon>
					Create Task
				</v-btn>
			</div>
		</div>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Unsaved changes`" 
			:content="'Are you sure you want to leave this window without saving changes?'"
			:ok="'Yes, exit'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="$emit('close')"
		/>
	</div>
</template>
<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import AssignedTreeSelection from "@/components/jobs/assigned_tree_selection.vue";
import SuitCase from "@/components/icons/suitcase.vue";
import Phase from "@/components/icons/phase.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import DateMulti from "@/components/date/date_multi.vue";
import DateTime from "@/components/date/date_time.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

import { validTime } from "@/common/validTime.js";
import { validHour } from "@/common/validHour.js";
import { budgetToMinutes, minutesToBudget } from "@/common/budgetToMinute.js";
import moment from 'moment';
import config from "@/config.js";

const NOTE_ITEMS = [
	{
		text: 'Create Note',
		value: 'create',
	},
	{
		text: 'Attach Note',
		value: 'attach',
	},
];
const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;
const FREELANCER = 4;

const Manually ="manually";
const Automatically = "automatically";

/** 0-'',1-AC,2-OC */
const AC_Type = 1;
const OC_Type = 2;

const DescriptionLimit = 60;

const NUMERICAL_REG = config.numerical_reg;

const TEXT_COLOR = config.text_color.default;
const Error_Flag = 'Traffic;';

const Completed_Phase = 1;
const TPc = 'TPc';
const JOr = 'JOr';
const TSr = 'TSr';
/** If selected the user will be able to change the scheduled dates of a subtask beyond the dates of the containing task */
const TrScO = 'TrScO';

export default {
	name: 'NewTask',
	props: {
		color: {
			type: String,
			default: ''
		},
		taskDetail: {
			type: Object,
			default: null,
		},
		isSubTaskCreation: {
			type: Boolean,
			default: false
		},
		isDuplication: {
			type: Boolean,
			default: false
		},
		joid: {
			type: Number,
			default: 0
		},
		jpid: {
			type: Number,
			default: 0
		},
		tasid: {
			type: Number,
			default: 0
		},
		startTime: {
			type: String,
			default: ''
		},
		endTime: {
			type: String,
			default: ''
		},
		taskName: {
			type: String,
			default: ''
		},
		taskKind: {
			type: Object,
			default: null,
		},
		taskAmount: {
			type: Number,
			default: 0
		},
		taskDate: {
			type: Array,
			default: () => []
		}
	},
	data() {
		this.manually = Manually;
		this.automatically = Automatically;
		this.ac_type = AC_Type;
		this.oc_type = OC_Type;

		return {
			loading: false,
			error_msg: '',
			currency: { id: 0, symbol:"A$" },

			job: { id: 0, display_name: '', valid: true },
			jobItems: [],
			jobLoading: false,
			jobSearch: null,
			job_type: null,
			job_invalid_status_ids: [],

			phase: null,
			phaseItems: [],

			kind: { id: 0, display_name: '' },
			kind_selected: null,
			kindParams: {
				select_kinds: true,
				select_items: false,
				timesheet_kinds: true,
				overhead_mode: 0,
				traffic_only: true
			},

			task_name: null,
			task_status: null,
			task_statusses: [],

			priority: 0,
			priority_levels: [1, 2, 3, 4, 5],

			assigned: [],
			assigned_to: [],
			close_selection: 0,

			account_director: null,
			account_director_items: [],

			amount: 0,
			budget: '',
			unit: '0',
			budget_type: 0,
			unit_type: null,

			charge_rate_total: 0,

			note_items: NOTE_ITEMS,
			radio_group: Manually,
			note: null,
			content: '',

			date_start_init: '',
			date_end_init: '',
			date_start: null,
			date_end: null,
			time_start: null,
			time_end: null,
			time_start_init: '',
			time_end_init: '',
			days: 0,
			workdays: [],
			date_range: [],

			isAllday: true,
			isRecurring: false,
			isActive: false,
			unsaved_visible: false,
			click_flag: 0,
			ac_oc: null,

			visible_notice: false,
			notice_text: [],
			tid: null,

			error_job_flag: false,
			error_phase_flag: false,
			error_task_status_flag: false,
			error_task_name_flag: false,
			button_click_flag: false,

			start_time_error: false,
			end_time_error: false,

			rules: [
				value => {
					return validHour(value);
				}
			]
		}
	},
	components: {
		ProgressLinear,
		AssignedTreeSelection,
		SuitCase,
		Phase,
		KindTreeSelection,
		DialogNotice,
		DeleteConfirmDialog,
		DateMulti,
		DateTime
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {		
		await this.initSetupTime();
		await this.getTaskStatus();
		await this.getJobStatusIds();

		if (this.tasid !== 0 || ((this.isSubTaskCreation || this.isDuplication) && this.taskDetail)) {
			const id = this.tasid !== 0 ? this.tasid : this.taskDetail.id;
			this.initTask(id);
		}

		if (this.joid !== 0) {
			await this.getJobById(this.joid);
		}

		if (this.startTime.length !== 0 && this.tasid === 0) {
			this.isAllday = false;

			const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
			this.date_start_init = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
			this.date_end_init = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
			this.date_start = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
			this.date_end = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
			this.time_start = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a') : null;
			this.time_start_init = this.time_start ? this.time_start : '';
		}

		if (this.taskName.length !== 0) {
			this.task_name = this.taskName;
			this.task_status = (this.task_statusses.filter(status => { return status.desc.toLowerCase().includes('active')}))[0];
			await this.getKindByName(this.taskKind.display_name);
			
			this.amount = this.taskAmount;
			if (this.budget_type === 2) {
				this.getBudget();
			}

			this.date_start_init = this.taskDate[0];
			this.date_end_init = this.taskDate[1];

			this.date_start = this.taskDate[0];
			this.date_end = this.taskDate[1];

			if (this.date_end && this.date_end.length !== 0 && this.date_start <= this.date_end) {
				const start_moment = moment(this.date_start);
				const end_moment = moment(this.date_end);
				const days = end_moment.diff(start_moment, 'days') + 1;

				const date_arr = [];
				for (let index = 0; index < days; index++) {
					const date = moment(this.date_start).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
					if (this.workdays.includes(week_str.toLocaleLowerCase())) {
						date_arr.push(week_str);
					}
				}

				this.days = date_arr.length;
			}
		}
	},
	watch: {
		jobSearch(val) {
			val && (this.job ?  val !== this.job.display_name : true) && this.jobQuery(val);
		},
		date_start() {
			if (this.date_start && this.date_start.length !== 0 && this.date_start <= this.date_end) {
				const start_moment = moment(this.date_start);
				const end_moment = moment(this.date_end);
				const days = end_moment.diff(start_moment, 'days') + 1;

				const date_arr = [];
				for (let index = 0; index < days; index++) {
					const date = moment(this.date_start).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
					if (this.workdays.includes(week_str.toLocaleLowerCase())) {
						date_arr.push(week_str);
					}
				}

				this.days = date_arr.length;
			}
			this.isActive = this._isActive();
		},
		date_end() {
			if (this.date_end && this.date_end.length !== 0 && this.date_start <= this.date_end) {
				const start_moment = moment(this.date_start);
				const end_moment = moment(this.date_end);
				const days = end_moment.diff(start_moment, 'days') + 1;

				const date_arr = [];
				for (let index = 0; index < days; index++) {
					const date = moment(this.date_start).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
					if (this.workdays.includes(week_str.toLocaleLowerCase())) {
						date_arr.push(week_str);
					}
				}

				this.days = date_arr.length;
			}
			this.isActive = this._isActive();
		},
		task_name() {
			this.isActive = this._isActive();
		},
		unit() {
			this.isActive = this._isActive();
		},
		amount() {
			this.isActive = this._isActive();
		},
		budget() {
			this.isActive = this._isActive();

			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			if (this.budget.length !== 0 && validTime(time_start_tmp)) {
				const mins = budgetToMinutes(this.budget);
				const start = moment(time_start_tmp, 'h:mma');
				const end = start.add(mins, 'minutes').format('h:mm a');
				this.time_end = end;			
			}
		}
	},
	computed: {
		user_abid() {
			let abid = 0;
			const user = this.$store.state.user;

			if (user && user.addressbook) {
				abid = user.addressbook.id;
				this.getCurrency(abid);
			}		

			return abid;
		},
		completedPhasePrivilege() {
			let isCompletedPhasesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TPc)) {
				isCompletedPhasesTmp = true;
			}
			return isCompletedPhasesTmp
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp;
		},
		outsideBoundsPrivilege() {
			let isOutsideBoundsTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrScO)) {
				isOutsideBoundsTmp = true;
			}
			return isOutsideBoundsTmp;
		},
		showBudget() {
			let showBudget_tmp = true;

			if (this.budget_type === 2 && this.$store.state.privileges && this.$store.state.privileges.length !== 0 && !this.$store.state.privileges.includes(TSr)) {
				showBudget_tmp = false;
			}

			return showBudget_tmp;
		}
	},
	methods: {
		async getTaskStatus() {
			this.loading = true;

			const url = '/api/tasks/meta';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					// For some reason axios isn't always converting our data
					let response_obj = null;
					if ((typeof val.data) == "string") {
						response_obj = JSON.parse(val.data);
					}

					const { status, meta, reason } = response_obj;

					if (status == "OK") {
						this.task_statusses = meta.statusses;

						const default_status = this.task_statusses.filter(t => { return t.isdefault === true });
						this.task_status = default_status[0];

						this.priority = meta.default_priority + 1;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message) ;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getJobStatusIds() {
			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		async initSetupTime() {
			let url = '/api/config/setup/time';
			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						for (const [key, value] of Object.entries(data)) {
							if (key.startsWith('s')) {
								if (value.length !== 0) {
									const week_key = key.split('_');
									this.workdays.push(week_key[1])
								}
							}
						}

					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		async getJobById(id) {
			this.loading = true;
			
			const url = `/api/jobs/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						const description = data.short.length > DescriptionLimit
							? data.short.slice(0, DescriptionLimit) + '...'
							: data.short;
						
						let is_disabled = false;
						if (this.completedJobPrivilege) {
							is_disabled = this.job_invalid_status_ids.includes(data.status.id) ? true : false;
						}

						const job_selected = {
							id: data.id,
							display_name: `${data.code} - ${description}`,
							acc_dir: data.acc_dir,
							acc_exec: data.acc_exec,
							job_type: data.job_type,
							currency_id: data.currency.id,
							currency: data.currency,
							disabled: is_disabled,
							valid: !is_disabled
						};

						this.jobItems.push(job_selected);
						this.job = job_selected;
						this.onJobSelected(job_selected)
					} 
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				})
				.finally(() => {
					this.loading = false
				});
		},
		async getKindByName(name) {
			this.loading = true;

			const params = [];
			for (const [key, value] of Object.entries(this.kindParams)) {
				params.push(`${key}=${value}`);
			}
			params.push(`name=${name}`)

			let url = "/api/kinds";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						if (data.length === 0) {
							this.kind_selected = this.taskKind;
							this.kind = this.taskKind;
							this.budget_type = 1;
						} else {
							this.kind_selected = data[0];
							this.kind = data[0];
							this.budget_type = data[0].budget_type;
						}
					} 
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				})
				.finally(() => {
					this.loading = false
				});
		},
		async initTask(task_id) {
			this.loading = true;

			const url = `/api/tasks/${task_id}?comments=true&worked_on=true`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						/** init job filed */
						const is_valid = this.completedJobPrivilege ? config.job_status_group_nomal.includes(data.job_status.status) :true;

						const job_tmp = {
							id: data.job.id,
							display_name: `${data.job.code} - ${data.job.name}`,
							valid: is_valid
						};
						this.jobItems.push(job_tmp);
						this.job = job_tmp;

						/** init phase field */
						const phase_obj = {
							id: data.phase.id,
							display_name: data.phase.name
						}
						this.phase = phase_obj;
						this.phaseItems.push(this.phase);

						/** init task status */
						this.task_status = data.status;

						/** init task name */
						if (this.isDuplication || this.tasid !== 0) {
							this.task_name = data.title;
						}
						if (this.isSubTaskCreation) {
							this.task_name = `Sub-${data.title}`;
						}
						
						/** init kind field */
						const kind = data.kind ? JSON.parse(JSON.stringify(data.kind)) : null;
						kind['display_name'] = data.kind ? kind.name : '';
						this.kind_selected = kind;
						this.kind = kind;

						/** init others */
						this.currency = data.currency;
						this.job_type = data.job_type;
						this.account_director = data.acc_exec;
						this.account_director_items = [data.acc_exec];
						this.ac_oc = data.acoc;

						if (data.job_type.is_overhead) {
							this.kindParams.overhead_mode = 2;
						} else {
							this.kindParams.overhead_mode = 1;
						}
						
						this.budget_type = data.budget_type;

						/** init assigned */
						if (data.For) {
							this.assigned_to = this._buildAssigned(data.For);
							this.assigned = this._buildAssigned(data.For);
						}

						/** init date */
						this.isAllday = (this.startTime.length !== 0 || this.endTime.length !== 0) ? false : !data.has_time;

						if (this.startTime.length !== 0) {
							const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
							this.date_start_init = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
							this.date_end_init = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
							this.date_start = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
							this.date_end = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : '';
						} else {
							this.date_start_init = data.start_date ? moment(data.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
							this.date_end_init = data.end_date ? moment(data.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
							this.date_start = data.start_date ? moment(data.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
							this.date_end = data.end_date ? moment(data.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
						}

						if (this.startTime.length !== 0) {
							const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
							this.time_start = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a') : null;
							this.time_start_init = this.time_start ? this.time_start : '';
						} else {
							this.time_start = data.has_time && data.start_datetime ? moment(new Date(data.start_datetime)).format('h:mm a') : null;
							this.time_start_init = this.time_start ? this.time_start : '';
						}

						if (this.endTime.length !== 0) {
							const is_valid = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();
							this.time_end = is_valid ? moment(this.endTime, 'YYYY-MM-DD HH:mm').format('h:mm a') : null;
							this.time_end_init = this.time_end ? this.time_end : '';
						}
						if (this.startTime.length === 0 && this.endTime.length === 0) {
							this.time_end = data.has_time && data.end_datetime ? moment(new Date(data.end_datetime)).format('h:mm a') : null;
							this.time_end_init = this.time_end ? this.time_end : '';
						}

						if (this.isSubTaskCreation && this.startTime.length !== 0 && this.endTime.length !== 0) {
							const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
							if (is_valid) {
								const start_format = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('HH:mm');
								const end_format = moment(this.endTime, 'YYYY-MM-DD HH:mm').format('HH:mm');

								const start = moment(start_format, 'HH:mm');
								const end = moment(end_format, 'HH:mm');
								const diff = end.diff(start, 'm');

								this.budget = minutesToBudget(diff);
								if (this.budget !== 0) {
									this.getAmount();
								}
							}
						}
						
						if (this.isDuplication || this.tasid !== 0) {
							/** init budget */
							this.amount = data.value;
							this.budget = minutesToBudget(data.budget);

							/** init date range */
							if (!this.outsideBoundsPrivilege) {
								if (data.parent) {
									if (data.parent.start_date !== null && data.parent.end_date !== null) {
										const start_date = moment(data.parent.start_date).format('YYYY-MM-DD');
										const end_date = moment(data.parent.end_date).format('YYYY-MM-DD');
										this.date_range = [start_date, end_date];
									} else {
										if (data.phase.start_date !== null && data.phase.end_date !== null) {
											this.date_range = [data.phase.start_date, data.phase.end_date];
										} else {
											this.date_range = [];
										}
									}
								} else {
									if (data.phase.start_date !== null && data.phase.end_date !== null) {
										this.date_range = [data.phase.start_date, data.phase.end_date];
									} else {
										this.date_range = [];
									}
								}
							}
						}

						/** init subtask date range */
						if (this.isSubTaskCreation && !this.outsideBoundsPrivilege) {
							if (data.start_date !== null && data.end_date !== null) {
								const start_date = moment(data.start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
								const end_date = moment(data.end_date, 'Do MMM YYYY').format('YYYY-MM-DD');
								this.date_range = [start_date, end_date];
							} else {
								if (data.phase.start_date !== null && data.phase.end_date !== null) {
									this.date_range = [data.phase.start_date, data.phase.end_date];
								} else {
									this.date_range = [];
								}
							}
						}

					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
					this.loading = false;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getCurrency(user_abid) {
			const url = "/api/addressbook/" + user_abid;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					const json = d.data;
					const { status, data, reason } = json;

					if (status == "OK") {
						this.currency = data.currency;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}					
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		async getChargerate(params) {
			let url = '/api/config/rates/chargerate';
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.charge_rate_total += data;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		jobQuery(key) {
			this.jobLoading = true;
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];
						
						this.jobItems = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;
							
							let is_disabled = false;
							if (this.completedJobPrivilege) {
								is_disabled = this.job_invalid_status_ids.includes(d.status.id) ? true : false;
							}

							const obj = {
								id: d.id,
								display_name: description,
								acc_dir: d.acc_dir,
								acc_exec: d.acc_exec,
								job_type: d.job_type,
								currency_id: d.currency.id,
								currency: d.currency,
								disabled: is_disabled,
								valid: !is_disabled
							};

							return obj;
						});

					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch(e => {
					this.error_msg = this._errorMessageFormat(e.message);
				})
				.finally(() => {
					this.jobLoading = false
				});
		},
		async onJobSelected(job_selected) {
			this.error_job_flag = false;

			if (job_selected) {
				this.currency = job_selected.currency;
				this.job_type = job_selected.job_type;
				this.account_director = job_selected.acc_dir;
				this.account_director_items = [job_selected.acc_dir];
				await this.getPhase(job_selected.id);

				if (job_selected.job_type.is_overhead) {
					this.kindParams.overhead_mode = 2;
				} else {
					this.kindParams.overhead_mode = 1;
				}

				if (job_selected && this.phase && this.kind && this.kind.id !== 0) {
					this._checkKind(job_selected.id, this.kind.id, this.phase.id)
						.then(val => {
							if (!val) {
								this.kind = { id: 0, display_name: '' };
								this.kind_selected = { id: 0, display_name: '' };
							}
						})
						.catch((reason) => {
							this.error_msg = reason;
						});
				}

				const budget = budgetToMinutes(this.budget);
				if (budget !== 0) {
					this.getAmount();
				}
			} else {
				this.currency = { id: 0, symbol:"A$" };
				this.job_type = null;
				this.account_director = null;
				this.account_director_items = [];
				this.phase = null;
				this.phaseItems = [];
				this.kindParams.overhead_mode = 0;
			}

			this.isActive = this._isActive();
		},
		async getPhase(job_id) {
			await axios.get('/api/jobs/' + job_id + '/phases', {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.forEach(d => {
							if (this.completedPhasePrivilege) {
								d['disabled'] = false;
							} else {
								d['disabled'] = d.status === Completed_Phase ? true : false;
							}
						});
						this.phaseItems = data;

						// auto assign our phase, select the first one if there are multiple.
						const phases_arr = data;

						if (this.jpid !== 0) {
							const phase_filter = phases_arr.filter(p => { return p.id === this.jpid });
							this.phase = phase_filter.length === 0 ? phases_arr[0] : phase_filter[0];
						} else {
							this.phase = phases_arr[0];
						}

						if (this.phase && !this.isSubTaskCreation && !this.outsideBoundsPrivilege) {
							if (this.phase.start_date !== null && this.phase.end_date !== null) {
								this.date_range = [this.phase.start_date, this.phase.end_date];
							} else {
								this.date_range = [];
							}
						}

						this.isActive = this._isActive();
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}

				})
				.catch(msg => {
					this.error_msg = this._errorMessageFormat(msg);
				})
		},
		onPhaseChange() {
			this.error_phase_flag = false;
			if (this.job && this.job.id === 0) {
				this.error_job_flag = true;
			}
			
			if (this.phase && !this.isSubTaskCreation && !this.outsideBoundsPrivilege) {
				if (this.phase.start_date !== null && this.phase.end_date !== null) {
					this.date_range = [this.phase.start_date, this.phase.end_date];
				} else {
					this.date_range = [];
				}
			}

			this.onButtonActive();
		},
		onStatusChange() {
			this.error_task_status_flag = false;

			if (this.job && this.job.id === 0) {
				this.error_job_flag = true;
			}
			if (!this.phase) {
				this.error_phase_flag = true;
			}

			this.onButtonActive();
		},
		onTaskNameChange() {
			this.error_task_name_flag = false;
			
			if (this.job && this.job.id === 0) {
				this.error_job_flag = true;
			}
			if (!this.phase) {
				this.error_phase_flag = true;
			}
			if (!this.task_status) {
				this.error_task_status_flag = true;
			}

			this.onButtonActive();
		},
		getBudgetClass(budget_type) {
			let class_str = '';
			if (budget_type === 0) {
				class_str = 'item-text-disable';
			}

			if (budget_type === 1) {
				class_str = this.amount === 0 && this.click_flag > 0 ? 'item-text item-text-error':'item-text item-text-able';
			}

			if (budget_type === 2) {
				class_str = this.budget.length === 0 && this.click_flag > 0 ? 'item-text item-text-error':'item-text item-text-able';
			}

			if (budget_type === 3) {
				class_str = Number(this.unit) === 0 && this.click_flag > 0 ? 'item-text item-text-error':'item-text item-text-able';
			}

			return class_str;
		},
		getHoursClass(budget_type) {
			let class_str = '';
			if (budget_type === 0 || budget_type === 1) {
				class_str = 'item-text-disable';
			}

			if (budget_type === 2) {
				class_str = this.budget.length === 0 && this.click_flag > 0 ? 'item-text item-text-error':'item-text item-text-able';
			}

			if (budget_type === 3) {
				class_str = Number(this.unit) === 0 && this.click_flag > 0 ? 'item-text item-text-error':'item-text item-text-able';
			}

			return class_str;
		},
		onKind(value) {
			this._requiredCheck();

			if (value) {
				this.budget_type = value.budget_type;
				this.unit_type = value.unit_type;
				if (this.unit_type) {
					const unit = this.unit_type.decimals !== null ? Number.parseFloat(this.unit).toFixed(this.unit_type.decimals) : '0.00';
					this.unit = unit;
				}
				
				if (value.budget_type === 3) {
					this.date_start = null;
					this.dare_end = null;
				}

				this.kind = value;

				if (value.budget_type === 2) {
					const budget = budgetToMinutes(this.budget);
					if (budget !== 0) {
						this.getAmount();
					}
				}

				if (value.def_role && value.def_role.id) {
					const obj = {
						id: `${ROLES}_${value.def_role.id}`,
						name: value.def_role.name,
						type: ROLES,
						kind: true,
						tooltip: 'Role'
					};

					const existed_arr = this.assigned.filter(a => { return a.id === obj.id });
					if (existed_arr.length === 0) {
						this.assigned.push(obj);
					}
					this.onAssignChange(this.assigned);
				} else {
					if (value.def_department && value.def_department.id) {
						const obj = {
							id: `${DEPARTMENTS}_${value.def_department.id}`,
							name: value.def_department.name,
							type: DEPARTMENTS,
							kind: true,
							tooltip: 'Department'
						};
					
						const existed_arr = this.assigned.filter(a => { return a.id === obj.id });
						if (existed_arr.length === 0) {
							this.assigned.push(obj);
						}
						this.onAssignChange(this.assigned);
					}
				}
			} else {
				this.kind = { id: 0, display_name: '' };
				this.budget = '';
				this.budget_type = 0;
				this.unit = 0;
				this.unit_type = null;
				this.amount = 0;
			}
			
			this.isActive = this._isActive();
		},
		onRecurring(val) {
			if (val) {
				this.radio_group = Automatically;
			} else {
				this.radio_group = Manually;
			}
		},
		onAmount(value) {
			this._requiredCheck();

			this.amount = Number(value);

			if (this.budget_type === 2) {
				this.getBudget();
			}
		},
		onBudget(budget) {
			this.start_time_error = false;
			this.end_time_error = false;

			this._requiredCheck();

			if (validHour(budget)) {
				let result = budget;
				if (NUMERICAL_REG.test(budget)) {
					result = Number(budget);
					result = `${result}h`;
				}

				const duration_minute = budgetToMinutes(result);
				this.budget = minutesToBudget(duration_minute);

				const time_start = this.time_start ? this.time_start : '0';
				let time_start_tmp = time_start.replace(/\s+/g,"");

				if (this.budget.length !== 0 && validTime(time_start_tmp)) {
					const mins = budgetToMinutes(this.budget);
					const start = moment(time_start_tmp, 'HH:mma');
					const end = start.add(mins, 'minutes').format('h:mm a');
					this.time_end = end;			
				}

				if (this.budget_type === 2) {
					this.getAmount();
				}
			}
		},
		async getAmount() {
			const params_arr = this._getChargeRateParams();

			if (params_arr.length === 0) {
				this.charge_rate_total = 0;

				await this.getChargerate(params_arr[0]);

				const units = budgetToMinutes(this.budget);
				const amount = (units / 60) * this.charge_rate_total;
				this.amount =  Number.parseFloat(amount.toFixed(2));

			} else {
				this.charge_rate_total = 0;

				for (let index = 0; index < params_arr.length; index++) {
					await this.getChargerate(params_arr[index]);
				}

				const units = budgetToMinutes(this.budget);
				const amount = (units / 60) * (this.charge_rate_total / params_arr.length);
				this.amount = Number.parseFloat(amount.toFixed(2));
			}
		},
		async getBudget() {
			const params_arr = this._getChargeRateParams();

			if (params_arr.length === 0) {
				this.charge_rate_total = 0;

				await this.getChargerate(params_arr[0]);

				const units = (this.amount / this.charge_rate_total) * 60;
				const units_int =  Number.parseInt(units.toFixed());
				this.budget = minutesToBudget(units_int);
				
			} else {
				this.charge_rate_total = 0;

				for (let index = 0; index < params_arr.length; index++) {
					await this.getChargerate(params_arr[index]);
				}

				const charge_rate_average = this.charge_rate_total / params_arr.length;
				const units = (this.amount / charge_rate_average) * 60;
				const units_int =  Number.parseInt(units.toFixed());
				this.budget = minutesToBudget(units_int);
			}			
		},
		onUnits(value) {
			if (value.length === 0) return;

			this._requiredCheck();

			if (this.unit_type.decimals === 0) {
				this.unit = Math.ceil(value);
			} else {
				this.unit = Number.parseFloat(value).toFixed(this.unit_type.decimals);
			}
		},
		onPriorityChange() {
			this._requiredCheck();

			this.onButtonActive();
		},
		onAssignChange(event) {
			if (this.job && this.job.id === 0) {
				this.error_job_flag = true;
			}
			if (!this.phase) {
				this.error_phase_flag = true;
			}
			if (!this.task_status) {
				this.error_task_status_flag = true;
			}
			if (this.task_name === null || (this.task_name && this.task_name.length === 0)) {
				this.error_task_name_flag = true;
			}
			const event_keys = (event.map(e => { return e.id})).join();
			const origin_keys = (this.assigned_to.map(a => { return a.id})).join();

			if (event_keys !== origin_keys) {
				this.assigned_to = event;
				this.assigned = event;

				if (this.budget_type === 2) {
					this.getAmount();
				}
			}			
		},
		onDateChange(date_arr) {
			this.error_msg = '';

			if (date_arr.length === 0) {
				this.date_start = '';
				this.date_end = '';
				this.days = date_arr.length;
			}

			if (date_arr.length === 2) {
				this.date_start = date_arr[0];
				this.date_end = date_arr[1];
			}
			
			this.isActive = this._isActive();
		},
		onTimeStartChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;
			
			this.time_start = time;

			this.onStartTime();
			this.isActive = this._isActive();
		},
		onTimeEndChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_end = time;

			this.onEndTime();
			this.isActive = this._isActive();
		},
		onStartTime() {
			const time_start = this.time_start ? this.time_start: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (this.budget_type === 2) {
				if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const time1 = moment(time_start_tmp, 'HH:mma');
					const time2 = moment(time_end_tmp, 'HH:mma');
					const budget = time2.diff(time1, 'minutes');

					if (budget < 0) {
						this.start_time_error = true;
					} else {
						this.budget = minutesToBudget(budget);
					}

					this.getAmount();
				}
			}
		},
		onEndTime() {
			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (this.budget_type === 2) {
				if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const time1 = moment(time_start_tmp, 'HH:mma');
					const time2 = moment(time_end_tmp, 'HH:mma');
					const budget = time2.diff(time1, 'minutes');

					if (budget < 0) {
						this.end_time_error = true;
					} else {
						this.budget = minutesToBudget(budget);
					}

					this.getAmount();
				}
			}
		},
		onButtonActive() {
			this.isActive = this._isActive();
		},
		onCreateCheck() {
			if (!this.isActive) {
				this.click_flag += 1;
				return;
			}
			if (this.button_click_flag) return;
		},
		async onCreate() {
			if (this.button_click_flag) return;

			this.button_click_flag = true;
			
			let params_obj = null;
			await this._buildParams().then(val => {
				params_obj = val;
			});

			const url = "/api/tasks";

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Task has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		onCreateTaskClose() {
			if (this.isActive) {
				this.unsaved_visible = true;
			} else {
				this.$emit('close');
			}
		},
		_isActive() {
			let isActive = false;

			if (this.job && this.job.id !== 0 && this.job.valid && this.task_name && this.phase && this.task_status) {
				isActive = true;
			}

			return isActive;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.$emit('close');			
		},
		_buildAssigned(array) {
			const result_arr = [];

			array.forEach(a => {
				const obj = {};
				if (a.Type === ALLEMPLOYEES) {
					obj['id'] = `${a.is_freelancer && !a.is_employee ? FREELANCER : ALLEMPLOYEES}_${a.AbookId}`,
					obj['type'] = a.is_freelancer && !a.is_employee ? FREELANCER : a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				if (a.Type === ROLES) {
					obj['id'] = `${ROLES}_${a.RoleId}`,
					obj['type'] = a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				if (a.Type === DEPARTMENTS) {
					obj['id'] = `${DEPARTMENTS}_${a.DepartmentId}`,
					obj['type'] = a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				result_arr.push(obj);
			});
			
			return result_arr;
		},
		async _buildParams() {
			const params_obj = {};

			// assigned
			const assigned_tmp = [];
			if (this.assigned_to.length !== 0) {
				this.assigned_to.forEach(a => {
					const assigned_id = typeof(a.id) === 'string' ? a.id : a.id.toString();
					const assigned_id_split = assigned_id.split('_');

					if (assigned_id_split.length > 1) {
						const assigned_obj = {};
						const mode = Number(assigned_id_split[0]) === FREELANCER ? ALLEMPLOYEES : assigned_id_split[0];
						assigned_obj['mode'] = Number(mode);

						if (Number(mode) === DEPARTMENTS) {
							assigned_obj['department_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ROLES) {
							assigned_obj['role_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ALLEMPLOYEES) {
							assigned_obj['abook_id'] = Number(assigned_id_split[1]);
						}

						assigned_tmp.push(assigned_obj);
					}
				});
			}
			params_obj['assigned'] = assigned_tmp;

			// kind
			if (this.kind.id !== 0) {
				params_obj['kind_id'] = this.kind.id;
			}

			// budget_type
			const budget_type = this.budget_type;
			params_obj['budget_type'] = budget_type;

			if (budget_type === 0) {
				params_obj['units'] = 0;
				params_obj['charge_rate'] = 0;
				params_obj['value'] = 0;
			}

			if (budget_type === 1) {
				params_obj['value'] = Number(this.amount);
			}

			if (budget_type === 2 || budget_type === 3) {
				const units = budget_type === 2 ? budgetToMinutes(this.budget) : Number(this.unit);
				params_obj['units'] = units;

				const params_arr = this._getChargeRateParams();
				if (this.assigned_to.length === 0) {
					this.charge_rate_total = 0;
					await this.getChargerate(params_arr[0]);

					params_obj['charge_rate'] = this.charge_rate_total;
					const value = budget_type === 2 ? (units / 60) * this.charge_rate_total : units * this.charge_rate_total;
					params_obj['value'] = Number(value.toFixed(2)); 
				} else {
					this.charge_rate_total = 0;

					for (let index = 0; index < params_arr.length; index++) {
						await this.getChargerate(params_arr[index]);
					}

					const charge_rate_average = this.charge_rate_total / assigned_tmp.length;
					params_obj['charge_rate'] = charge_rate_average;
					const value = budget_type === 2 ? (units / 60) * charge_rate_average : units * charge_rate_average;
					params_obj['value'] = value; 
				}
			}

			// days
			let has_time = false;
			if (this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0) {
				const start_time_tpm = moment(this.time_start, 'h:mm a').format('HH:mm');
				const end_time_tpm = moment(this.time_end, 'h:mm a').format('HH:mm');
				if (start_time_tpm < end_time_tpm) {
					has_time = true;
				}
			}

			const is_suggested = this.date_start && this.date_end && this.date_start <= this.date_end ? false : true;
			if (!is_suggested) {
				params_obj['days'] = this.days;
				params_obj['start'] = has_time ? moment(`${this.date_start}, ${this.time_start}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD h:mm a']).format('YYYYMMDD HH:mm:ss') : moment(this.date_start).format('YYYYMMDD');
				params_obj['end'] = has_time ? moment(`${this.date_end}, ${this.time_end}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD h:mm a']).format('YYYYMMDD HH:mm:ss') : moment(this.date_end).format('YYYYMMDD');
				
			}

			params_obj['is_suggested'] = is_suggested;
			params_obj['has_time'] = !is_suggested && has_time;
			params_obj['description'] = this.task_name;
			params_obj['phase_id'] = this.phase.id;
			params_obj['status_id'] = this.task_status.id;
			params_obj['priority'] = this.priority -1;

			params_obj['acoc'] = this.ac_oc !== AC_Type && this.ac_oc !== OC_Type ? 0 : this.ac_oc;
			params_obj['on_planning'] = true;
			params_obj['on_timeline'] = true;
			params_obj['text_color'] = TEXT_COLOR;

			if (this.isSubTaskCreation) {
				params_obj['parent_id'] = this.taskDetail.id;
			}
			
			return params_obj;
		},
		_getChargeRateParams() {
			const params_arr = [];

			if (this.assigned_to.length === 0) {
				const params = [];
				if (this.job && this.job.id !== 0) {
					params.push('job_id=' + this.job.id);
					params.push('currency_id=' + this.job.currency_id);
				}
				if (this.kind && this.kind.id !== 0) {
					params.push('kind_id=' + this.kind.id);
				}

				params_arr.push(params);
				
			} else {
				for (let index = 0; index < this.assigned_to.length; index++) {
					const params = [];
					if (this.job && this.job.id !== 0) {
						params.push('job_id=' + this.job.id);
						params.push('currency_id=' + this.job.currency_id);
					}
					if (this.kind && this.kind.id !== 0) {
						params.push('kind_id=' + this.kind.id);
					}
						
					const element = this.assigned_to[index];
					if (Number(element.type) === ROLES) {
						const split_ids = element.id.split('_');
						params.push('role_id=' + split_ids[split_ids.length -1]);
					}
					if (Number(element.type) === ALLEMPLOYEES) {
						const split_ids = element.id.split('_');
						params.push('employee_id=' + split_ids[split_ids.length -1]);
					}
					
					params_arr.push(params);
				}
			}

			return params_arr;
		},
		_requiredCheck() {
			if (this.job && this.job.id === 0) {
				this.error_job_flag = true;
			}
			if (!this.phase) {
				this.error_phase_flag = true;
			}
			if (!this.task_status) {
				this.error_task_status_flag = true;
			}
			if (this.task_name === null || (this.task_name && this.task_name.length === 0)) {
				this.error_task_name_flag = true;
			}
		},
		_errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		},
		_checkKind(job_id, kind_id, phase_id) {
			let url = `/api/jobs/${job_id}/can_do_kind`;

			const params = [];
			params.push("kiid=" + kind_id);
			params.push("jpid=" + phase_id);


			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							if (data.can_do_client && data.can_do_jobtype) {
								resolve(true);
							} else {
								resolve(false);
							}
							
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
	}
}
</script>
<style lang="scss" scoped>
.create-task-container {
  background: #FFFFFF;
  border-radius: 4px;

}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.item-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	// color: #37495F;
	opacity: 0.87;
}
.item-text-able {
	color: #37495F;
}
.item-text-error {
	color: #ff5252;
}
.item-text-disable {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #B9C2CB;
	opacity: 0.87;
}
.currency-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	color: #37495F;
	opacity: 0.87;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.item-and-icon {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.no-data-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #8996A5;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
.optional-text-red-keyword {
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.v-treeview--dense .v-treeview-node__root {
		min-height: 32px;
	}
	.v-treeview-node__content {
		min-height: 32px;
	}
	.v-text-field__suffix {
		color: #8996A5;
	}
}
</style>